import React, { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import ImageAnnotator from './ImageAnnotator';

const ImageEditorModal = ({ isOpen, onClose, image, onCropComplete, aspect }) => {
    return (
        <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <Dialog.Portal>
                <Dialog.Overlay className="step-media-url-modal-overlay" style={{ zIndex: 2000 }} />
                <Dialog.Content
                    className="step-media-url-modal"
                    style={{
                        zIndex: 2001,
                        maxWidth: '95vw',
                        width: '95vw',
                        height: '95vh',
                        maxHeight: '95vh',
                        padding: 0,
                        overflow: 'hidden',
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#1a1a1a', // Dark theme background
                        color: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.75)'
                    }}
                >
                    <div className="step-media-url-modal-header" style={{ padding: '0.75rem 1rem', borderBottom: '1px solid #333', backgroundColor: '#262626', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Dialog.Title style={{ margin: 0, fontSize: '1.25rem', fontWeight: 600, color: 'white' }}>
                            Editor de Imagem
                        </Dialog.Title>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Dialog.Close asChild>
                                <button className="step-media-url-modal-close" aria-label="Fechar" style={{ background: 'transparent', border: 'none', color: 'white', cursor: 'pointer' }}>
                                    <X size={24} />
                                </button>
                            </Dialog.Close>
                        </div>
                    </div>

                    <div style={{ flex: 1, position: 'relative' }}>
                        {image && (
                            <ImageAnnotator
                                image={image}
                                onSave={(finalBlob) => {
                                    onCropComplete(finalBlob);
                                    onClose();
                                }}
                                onCancel={onClose}
                            />
                        )}
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export default ImageEditorModal;
